import { render } from "./WaybillSelect.vue?vue&type=template&id=3da82938"
import script from "./WaybillSelect.vue?vue&type=script&lang=js"
export * from "./WaybillSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__